module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('panel', [_c('p', {
    slot: "header"
  }, [_vm._v("\n        " + _vm._s(_vm.item.email) + " "), _c('span', {
    staticClass: "gray"
  }, [_vm._v("(adres e-mail)")])]), _vm._v(" "), _c('table', {
    staticClass: "table info-table"
  }, [_c('tbody', [_c('tr', [_c('th', {
    staticClass: "short"
  }, [_vm._v("\n                    Należy do grup\n                ")]), _vm._v(" "), _c('td', _vm._l((_vm.item.groups), function(g) {
    return _c('p', [_c('a', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.$router.push({
            name: 'admin.email-groups.show',
            params: {
              id: g.id
            }
          })
        }
      }
    }, [_vm._v(_vm._s(g.name))])])
  }))]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("\n                    Status\n                ")]), _vm._v(" "), _c('td', [(_vm.item) ? _c('email-status', {
    attrs: {
      "item": _vm.item
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("\n                    Zaimportowany\n                ")]), _vm._v(" "), _c('td', [(_vm.item.was_imported) ? _c('div', [_c('span', {
    staticClass: "label-black"
  }, [_vm._v("Tak.")]), _vm._v(" "), _c('span', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.item.imported_at_formated))])]) : _vm._e(), _vm._v(" "), (!_vm.item.was_imported) ? _c('div', [_c('span', {
    staticClass: "label"
  }, [_vm._v("Nie")])]) : _vm._e()])])])]), _vm._v(" "), _c('p', {
    slot: "actions"
  }, [_c('ui-button', {
    attrs: {
      "type": "flat",
      "icon": "navigate_before",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.$router.push({
          name: 'admin.emails.dashboard'
        })
      }
    }
  }, [_vm._v("Wróć")]), _vm._v(" "), _c('ui-button', {
    attrs: {
      "type": "flat",
      "icon": "mode_edit",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.$router.push({
          name: 'admin.emails.edit',
          params: {
            id: _vm.id
          }
        })
      }
    }
  }, [_vm._v("Edytuj adres e-mail")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e67112ae","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/emails/Show.vue
// module id = 292
// module chunks = 0